import { render, staticRenderFns } from "./SugSelUser.vue?vue&type=template&id=f71bfd7a&"
import script from "./SugSelUser.vue?vue&type=script&lang=js&"
export * from "./SugSelUser.vue?vue&type=script&lang=js&"
import style0 from "./SugSelUser.vue?vue&type=style&index=0&id=f71bfd7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports